import { faComment, faScroll, faSwords, faTicket } from '@fortawesome/pro-solid-svg-icons';

export const TIP_PRODUCT_ID = 'c31bfeb5-360d-4d63-8cb8-5982b0d1482e';
export const FEE_PRODUCT_ID = '0c456a2c-ef6d-484f-8dcf-5f03dc26411b';
export const METAFY_CORE_ID = '23aaa6c0-bf03-4b0e-9ddf-3fc3e6d76323';
export const METAFY_PRO_ID = 'f67046a7-08c3-4c6b-88cd-d60dbd0aa443';

export const COUPON_TYPE = ['coupon_user', 'coupon_global'];

export const COUPON_TYPE_TOOLTIP_DISPLAY = ['coupon_user'];

export const PRODUCT_TYPE_UI_NAMES = {
  DEFAULT: 'Review',
  COACHING: 'Session',
  GUIDE: 'Guide',
  EVENT: 'Event'
} as const;

export const PRODUCT_TYPE_ICONS = {
  DEFAULT: faComment,
  COACHING: faSwords,
  GUIDE: faScroll,
  EVENT: faTicket
} as const;

export const PRODUCT_TYPE_VERBS = {
  DEFAULT: 'left a',
  COACHING: 'attended a',
  GUIDE: 'completed a',
  EVENT: 'joined an'
} as const;
